var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGainUniqueInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1157 -1682.703 104.242 148.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0078d6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_13_1",
    "data-name": "Symbol 13 \\u2013 1",
    transform: "translate(28 -2725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(1129 1042.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M50.672,0A50.742,50.742,0,0,0,0,50.672,50.363,50.363,0,0,0,10.843,82.127l1.61,2.04c2.254,2.791,4.616,5.8,6.656,8.7,4.294,6.227,8.8,13.527,9.125,20.72l.107,1.825v17.5c0,9.447,5.475,15.781,13.634,15.781h16.64c8.159,0,13.634-6.334,13.634-15.781V114.87c.537-8.266,5.046-17.5,13.1-26.732l.859-1.074c1.181-1.288,2.254-2.577,3.435-3.972h0a50.922,50.922,0,0,0,11.7-33.817,47.886,47.886,0,0,0-1.932-12.453l-7.085,7.193a47.25,47.25,0,0,1,.537,5.475A41.755,41.755,0,0,1,83.2,77.618c-1.074,1.288-2.147,2.577-3.328,3.865l-.859,1.074c-8.8,10.2-13.849,20.183-15.03,29.845H36.716c-.644-9.125-5.69-17.5-10.628-24.477-2.254-3.113-4.616-6.227-6.978-9.125l-1.61-2.04A42.373,42.373,0,0,1,8.588,50.672,42.135,42.135,0,0,1,50.672,8.588h1.61A42.451,42.451,0,0,1,81.053,21.471l6.119-6.119A51.3,51.3,0,0,0,52.712,0Zm-8.7,140.1c-4.4,0-5.046-4.509-5.046-7.193v-12.99H63.769v12.99c0,2.684-.644,7.193-5.046,7.193Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(1156.376 1057.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M96.247,14.3,49.011,61.536l-17.392-17.5L25.5,50.157,49.011,73.668l53.356-53.356Z",
    transform: "translate(-25.5 -14.3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainUniqueInsights);
export default __webpack_public_path__ + "static/media/gain-unique-insights.84c9a4c81fc5550cb30428def28d8375.svg";
export { ForwardRef as ReactComponent };